import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Carousel from '../Carousel/Carousel';
import Grid from './Grid';

const DynamicGrid = (props) => {
  const { children, className, columns, designLayout } = props;
  return designLayout === 'carousel' ? (
    <div className={'ds-v1'}>
      <Carousel
        id="dynamicGrid"
        slides={columns}
        className={cn('c-dynamic-grid c-dynamic-grid--carousel', className)}
      >
        {children}
      </Carousel>
    </div>
  ) : (
    <div className={'ds-v1'}>
      <Grid
        id={'dynamicGrid'}
        columns={columns}
        className={cn('c-dynamic-grid c-dynamic-grid--column', className)}
      >
        {children}
      </Grid>
    </div>
  );
};

export default DynamicGrid;

DynamicGrid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  columns: PropTypes.shape({
    mobile: PropTypes.number,
    mobileLandscape: PropTypes.number,
    tablet: PropTypes.number,
    tabletLandscape: PropTypes.number,
    desktop: PropTypes.number,
  }),
  designLayout: PropTypes.string,
  imagePosition: PropTypes.string,
};

DynamicGrid.defaultProps = {
  className: '',
  columns: {
    mobile: 1,
    mobileLandscape: 1,
    tablet: 1,
    tabletLandscape: 1,
    desktop: 1,
  },
};

DynamicGrid.convertToClasses = Grid.convertToClasses;
